<template>
    <div :class="[
    'component',
    'component__title',
    size ? `component__title--${size}` : '',
    margin ? `component__title--margin-${margin}` : '',
    color ? `component__title--${color}` : '',
    underline ? `component__title--underline` : '',
    raw ? `component__title--raw` : ''
    ]">
        <div class="container custom--flex">
            <div class="columns is-variable">
                <div class="column">
                    <span>
                        <slot></slot>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'component-title',
  props: {
    // one of: label/tiny/small/medium/large/extra-large
    size: {
      type: String
    },
    margin: {
      type: String
    },
    underline: {
      type: Boolean,
      default: false
    },
    raw: {
      type: Boolean,
      default: false
    },
    color: {
      type: String
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/componenttitle";
</style>
